import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { applyTokens } from "../../../utilities/applyTokens.js";
import { createLazyIcon } from "../../../utilities/createLazyIcon.js";
function AtlasSideSheetHeader({ onClose, titleText, closeButtonProps }) {
    const { tokens: { component: { sideSheet: { header }, }, semantic, }, } = useTheme();
    const CloseIcon = createLazyIcon(() => import("@diligentcorp/atlas-react-icons/dist/esm/lens/Close.js"));
    return (_jsxs(Box, Object.assign({ sx: Object.assign({ display: "flex", justifyContent: "space-between", alignItems: "center" }, applyTokens(header)) }, { children: [_jsx(Typography, Object.assign({ variant: "h3", fontWeight: semantic.fontWeight.emphasis.value, sx: { wordBreak: "break-word" } }, { children: titleText })), _jsx(Button, Object.assign({ onClick: onClose }, closeButtonProps, { children: _jsx(CloseIcon, {}) }))] })));
}
function AtlasSideSheetContent({ children }) {
    const { tokens: { component: { sideSheet }, }, } = useTheme();
    return (_jsx(Box, Object.assign({ sx: {
            overflowY: "auto",
            paddingRight: sideSheet.paddingRight.value,
            marginRight: `-${sideSheet.paddingRight.value}`,
        } }, { children: children })));
}
function AtlasSideSheetFooter({ children }) {
    const { tokens: { component: { sideSheet }, }, } = useTheme();
    const { footer } = sideSheet;
    return (_jsx(Box, Object.assign({ sx: { marginTop: "auto" } }, { children: _jsx(Box, Object.assign({ sx: Object.assign({ display: "flex", justifyContent: "space-between", alignItems: "center", marginLeft: `-${sideSheet.paddingLeft.value}`, marginRight: `-${sideSheet.paddingRight.value}`, paddingLeft: sideSheet.paddingLeft.value, paddingRight: sideSheet.paddingRight.value }, applyTokens(footer)) }, { children: children })) })));
}
export const SideSheetPersets = (tokens) => {
    const { core } = tokens;
    return {
        components: {
            Header: AtlasSideSheetHeader,
            Content: AtlasSideSheetContent,
            Footer: AtlasSideSheetFooter,
        },
        size: {
            large: {
                sx: {
                    ".MuiPaper-root": {
                        [`@media (min-width: ${core.breakpoints.tablet.min.value})`]: {
                            width: "75%",
                        },
                        [`@media (min-width: ${core.breakpoints.desktop.min.value})`]: {
                            width: "50%",
                        },
                    },
                },
            },
            medium: {
                sx: {
                    ".MuiPaper-root": {
                        [`@media (min-width: ${core.breakpoints.tablet.min.value})`]: {
                            width: "50%",
                        },
                        [`@media (min-width: ${core.breakpoints.desktop.min.value})`]: {
                            width: "33%",
                        },
                    },
                },
            },
        },
    };
};
//# sourceMappingURL=sideSheet.js.map